module.exports = __webpack_public_path__ + "static/img/9.6b5b144.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/zh/9.png
// module id = kyzm
// module chunks = 0